import { render, staticRenderFns } from "./Quote.vue?vue&type=template&id=680dae3e&scoped=true&"
import script from "./Quote.vue?vue&type=script&lang=ts&"
export * from "./Quote.vue?vue&type=script&lang=ts&"
import style0 from "./quote.scss?vue&type=style&index=0&id=680dae3e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "680dae3e",
  null
  
)

component.options.__file = "Quote.vue"
export default component.exports